<template>
    <div class="animated fadeIn equipmentList bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                    class="mt-3 contractPropertyTab"
                    activeKey="po"
                    variableWidth
                    :data="tabs">
                    <template slot="gofixTab:po">
                        <div class="text-right mb-1">
                            <gofix-button class="mr-10" label="Preview" @click="previewEntry"></gofix-button>
                            <gofix-button label="Compute" @click="saveEntry"></gofix-button>
                        </div>
                        <template v-for="(item, index) in arr_po">
                            <div :class="`mb-4 mt-3 unset-min-height `">
                                <div class="btn-action">
                                    <button :disabled="index == 0" @click="removeSection(index)">
                                        <svg v-b-tooltip.hover title="Delete section" data-v-04debbac="" width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path data-v-04debbac="" fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"></path></svg>
                                    </button>
                                    <button @click="addSection">
                                        <svg v-b-tooltip.hover title="Add new section" width="20" height="20" xmlns="http://w.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve"> <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z" /> <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z" /> </svg>
                                    </button>
                                    <button class="toggle" :class="item.class ? item.class : ''" @click="toggleCollapses(index);">
                                        <svg class="" v-b-tooltip.hover title="Collapse section" fill="#666666" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 96.154 96.154" xml:space="preserve"> <g> <path d="M0.561,20.971l45.951,57.605c0.76,0.951,2.367,0.951,3.127,0l45.956-57.609c0.547-0.689,0.709-1.716,0.414-2.61 c-0.061-0.187-0.129-0.33-0.186-0.437c-0.351-0.65-1.025-1.056-1.765-1.056H2.093c-0.736,0-1.414,0.405-1.762,1.056 c-0.059,0.109-0.127,0.253-0.184,0.426C-0.15,19.251,0.011,20.28,0.561,20.971z"/> </g> </svg>
                                    </button>
                                </div>
                                <POSection ref="poSection" :index="index"/>
                            </div>
                        </template>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import tabData from '@/data/_tabs';
import { mapGetters } from 'vuex';
import POSection from './po_component_section.vue'

export default {
    name: 'performance_assesment_lump_sum_payment',
    components: {
        POSection
    },
    data() {
        return {
            tabs: tabData.performance_assesment_data_entries,
            loading: false,
            supplier_contracts: [],
            arr_po: [
                {
                    class: 'active'
                },
            ],
            isActive: false
        }
    },
    watch: {
        ClientContractID: function(val) {
            //
        },
    },
    computed: {
        ...mapGetters({
            ClientContractID: 'ContractController/ClientContractID'
        })
    },
    created() {
        //
    },
    methods: {
        addSection() {
            this.arr_po.push({ class: 'active' })
        },
        removeSection(index) {
            this.$delete(this.arr_po, index)
        },
        toggleCollapses(id) {
            this.$root.$emit('bv::toggle::collapse', `collapse-` + id);

            if ( this.arr_po[id].class == '' ) {
                this.arr_po[id].class = 'active';
            } else {
                this.arr_po[id].class = '';
            }

            this.$forceUpdate();
        },
        previewEntry() {
            for(let i = 0; i < this.arr_po.length; i++) {
                this.$refs.poSection[i].previewEntry()
            }
        },
        saveEntry() {
            for(let i = 0; i < this.arr_po.length; i++) {
                this.$refs.poSection[i].saveEntry()
            }
        }
    }
}
</script>